<template>
    <div>
     
            <ul class="cf">
            
                <router-link    @click.native="changeIndicator(index)" :key="index" v-for="(navigator, index) in myNavigators" :class="[{'current':navigator.title == $store.state.breadcrumb[2].name}, navigator.class]" tag="li" :to="navigator.to"><a>{{navigator.title}}</a></router-link>
            </ul>
  
    </div>
</template>

<script>
import * as firebase from "firebase";
import { mapGetters } from "vuex";
export default {

  methods: {
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$store.dispatch("authLogout").then(() => {
            this.$router.push("/");
            this.$store.commit('savePath', '/index')

          });
             localStorage.removeItem('user-info') 

        })
        .catch(function(error) {
          console.log(error);
        });
    },
    changeIndicator(index) {
      if (index == this.myNavigators.length - 1) {
        this.signOut();
        return;
      }
      this.myNavigators.forEach(v => {
        v.isSelected = false;
      });
      this.myNavigators[index].isSelected = true;
    }
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "myNavigators"

      // ...
    ])
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/views/mySubviews/MyMenu.vue